import React, { Component } from 'react';

import i18n from 'i18n-react';

import { storageKeys } from 'config/settings.json';
import getFeatureFlags from 'helpers/getFeatureFlags';
import { legacyRemCss } from 'helpers/legacyRem';

import ContentHeader from 'components/ContentHeader';
import DiplomaButton from 'components/DiplomaButton';
import Progress from 'components/Progress';
import TrainingGrid from 'components/TrainingGrid';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';

const getTotalProgress = (res) => {
  let totalProgress = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters
      .filter((chapter) => !!chapter.specialization === false)
      .forEach((chapter) => {
        totalProgress += chapter.progress;
      });
  }
  return totalProgress;
};

const getTotalPages = (res) => {
  let totalPages = 0;
  if (res && res.data && res.data[0]) {
    const { chapters } = res.data[0];
    chapters
      .filter((chapter) => !!chapter.specialization === false)
      .forEach((chapter) => {
        totalPages += chapter.total_pages - 1;
      });
  }
  return totalPages;
};

// Makes sure progress is returned in percentage value
const calculateProgress = (progress, pages) => Math.floor((progress / pages) * 100);

// const ViewDiploma = ({ diploma }) => {
//   if (diploma !== 100) return null;

//   const hasViewedDiploma = localStorage.getItem('hasViewedDiploma');
//   if (hasViewedDiploma) return null;

//   localStorage.setItem('hasViewedDiploma', true);
//   setTimeout(() => {
//     document.getElementById('showDiplomaButton').click();
//   }, 2000);

//   return null;
// };

export default class TrainingView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      totalProgressValue: 0,
      diploma: 0,
      appId: 0,
      firstName: 'Firstname',
      lastName: 'Lastname',
      lang: 'en',
      trainLearnConfig: '',
      isAmbassador: false,
    };
  }

  componentDidMount() {
    StorageHandler.load(storageKeys.appInfo).then((appInfo) => {

      if (appInfo && appInfo.trainLearnConfig) {
        this.setState({ trainLearnConfig: appInfo.trainLearnConfig });
      }
    });
    this.mounted = true;
    this.getUserInfo();
    void getFeatureFlags().then((flags) => {
      if (this.mounted) {
        this.setState({ isAmbassador: !!flags.ambassador });
      }
    });
  }

  componentDidUpdate() {
    const { diploma, totalProgressValue } = this.state;

    if (totalProgressValue >= 100 && diploma !== 100) {
      this.setState({ diploma: 100 });
    }

    if (diploma >= 100) {
      const d = new Date(Date.now());
      const leading = (val) => `0${val}`.slice(-2);
      StorageHandler.load(storageKeys.user).then((user) => {
        if (user.training_graduated === null) {
          const obj = user;
          const date = `${d.getFullYear()}-${leading(d.getMonth() + 1)}-${leading(d.getDate())}`;
          DataHandler.matchAppId().then((appId) => {
            APIHandler.updateUser(appId, obj.email, [
              { param: 'sales_companion_registered', val: date },
              { param: 'training_started', val: date },
              { param: 'training_graduated', val: date },
            ]).then((res) => {
              if (res && obj && obj) {
                obj.sales_companion_registered = date;
                obj.training_started = date;
                obj.training_graduated = date;

                StorageHandler.save(storageKeys.user, obj);
              }
            });
          });
        }
      });
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getUserInfo() {
    StorageHandler.load(storageKeys.user).then((res) => {
      if (res) {
        const { email } = res;
        DataHandler.matchAppId().then((appId) => {
          APIHandler.getUserProgress(appId, email).then((userProgress) => {
            const totalProgress = getTotalProgress(userProgress);
            const totalPages = getTotalPages(userProgress);
            const percentage = calculateProgress(totalProgress, totalPages);
            this.setState({
              totalProgressValue: percentage >= 100 ? 100 : percentage,
            });

            if (percentage >= 100) {
              this.setState({ diploma: 100 });
            } else {
              this.setState({ diploma: 0 });
            }
          });
          StorageHandler.load(storageKeys.user).then((user) => {
            const { first_name: firstName, last_name: lastName, email } = user;
            this.setState({ firstName, lastName, email });
          });
          StorageHandler.load(storageKeys.lang).then(({ langFile: lang }) => {
            this.setState({
              appId: import.meta.env.VITE_APP_ID,
              lang,
            });
          });
        });
      } else {
        this.setState({ totalProgressValue: 0 });
      }
    });
  }

  render() {
    const { firstName, lastName, totalProgressValue, appId, email, trainLearnConfig, isAmbassador } = this.state;

    return (
      <div className="contentContainer trainingView" data-testid="training-view">
        <ContentHeader
          header={i18n.translate(`contentHeaders.${trainLearnConfig}`)}
          subtitle={i18n.translate(isAmbassador ? 'pageDescriptions.trainAmbassador' : 'pageDescriptions.train')}
          line={false}
        >
          <div className="container__Progress">
            <div className="container__progressBar">
              <Progress id="progress" value={totalProgressValue} />
              <span>
                {totalProgressValue}
                {i18n.translate('trainingScreens.percentageComplete')}{' '}
              </span>
            </div>
            <DiplomaButton
              className="trainingView__diploma-button"
              appId={appId}
              firstName={firstName}
              lastName={lastName}
              email={email}
              diplomaRate={totalProgressValue}
            />
            <style>
              {`#openWidget { display: block; bottom: ${legacyRemCss(4)}; }`}
            </style>
          </div>
        </ContentHeader>

        <TrainingGrid />
      </div>
    );
  }
}
